import PropTypes from 'prop-types';
import Select from 'components/Input/Select';
import DatePicker from 'components/Input/DatePicker';
import { useTranslation } from 'services/hooks';
import moment from 'moment';
import './style.css';

const CustomerProductDetails = ({ name, status, date, updateExpirationDate, toggleActive, id }) => {
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'customer_product_details';

	const options = [
		{
			id: 'option_active',
			description: getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_active_description`),
			value: true,
		},
		{
			id: 'option_inactive',
			description: getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_inactive_description`),
			value: false,
		},
	];

	const formattedDate = date ? moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

	return (
		<div className="CustomerProductDetails">
			<div className="CustomerProductDetails__wrapper">
				<div className="CustomerProductDetails__data__text">{name || getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_title`)}</div>
				<div className="CustomerProductDetails__select">
					<Select
						defaultValue={status || false}
						name="option_inactive"
						options={options || []}
						onChange={() => toggleActive(!status, id)}
					/>
				</div>
				<div className="CustomerProductDetails__data__date">
					<DatePicker
						label={date ? '' : getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_no_date`)}
						startDateName="expirationDate"
						startDateDefaultValue={formattedDate}
						onFromChange={e => updateExpirationDate(e, id)}
						startDisabled={!status}
					/>
				</div>
			</div>
		</div>
	);
};

export default CustomerProductDetails;

CustomerProductDetails.propTypes = {
	id: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
	status: PropTypes.bool.isRequired,
	toggleActive: PropTypes.func.isRequired,
	updateExpirationDate: PropTypes.func.isRequired,
};
